import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const LikeIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#f24006';
  return <Icon name={'reaction-like'} size={size} color={color} />;
};

export default React.memo(LikeIcon);
